import _ from 'lodash';
import { observable } from 'mobx';

export type MarginBaseType = 'percentage' | 'fixed';

export type CategoryType =
  | 'domestic'
  | 'domestic_hotel'
  | 'domestic_package'
  | 'foreign'
  | 'foreign_hotel'
  | 'domestic_rental_car'
  | 'domestic_flight'
  | 'domestic_shinkansen';

export type MarginTypeResponseArgs = {
  base_type: MarginBaseType;
  base_amount: number;
  category: CategoryType;
  id: number;
};

export type MarginTypeArgs = {
  baseType: MarginBaseType;
  baseAmount: number;
  category: CategoryType;
  id: number;
};

export const convertMarginTypeResponseToArgs = (response: MarginTypeResponseArgs) => {
  const args: MarginTypeArgs = {
    baseType: response.base_type,
    baseAmount: response.base_amount,
    category: response.category,
    id: response.id
  };
  return args;
};

export default class MarginType {
  @observable baseType: MarginBaseType;
  @observable baseAmount: number;
  @observable category: CategoryType;
  @observable id: number;

  constructor(args: MarginTypeArgs) {
    this.baseType = args.baseType;
    this.baseAmount = args.baseAmount;
    this.category = args.category;
    this.id = args.id;
  }

  calcMarginAmount(price: number, peopleNum: number, sectionNum = 1) {
    const target = this.baseType === 'fixed' ? peopleNum : price;
    const base = this.baseType === 'fixed' ? (this.baseAmount || 0) * sectionNum : (this.baseAmount || 0) / 100.0;
    return _.ceil(target * base);
  }

  describe(price: number, peopleNum: number, sectionNum = 1) {
    switch (this.baseType) {
      case 'fixed':
        return `${utils.formatPrice((this.baseAmount || 0) * sectionNum)} × ${peopleNum}名`;
      case 'percentage':
        return `${utils.formatPrice(price)} × ${this.baseAmount}％`;
      default:
        return `${utils.formatPrice((this.baseAmount || 0) * sectionNum)} × ${peopleNum}名`;
    }
  }
}
